import { connect } from "react-redux";
import TrainingModuleResultTable from "./components/TrainingModuleResultTable";
import { useParams } from "react-router-dom";


const TrainingModuleResults = () => {
	
const { classeId } = useParams();

	return (
		
	    <div>
			<TrainingModuleResultTable classeId={classeId} />
	    </div>
    );
};

const mapStateToProps = (state) => ({
  	  
});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingModuleResults);